export default __webpack_public_path__ + "260c288e8cfbc1568fa35a71b329c046.webp";